import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useImperativeHandle, useState } from 'react';
const MotionShakeImpl = lazy(async () => {
    const { animated, useSpring } = await import('@react-spring/web');
    function MotionShakeImpl({ children, className, ref }) {
        const [isShaking, setIsShaking] = useState(false);
        useImperativeHandle(ref, () => ({
            shake: () => setIsShaking(true),
        }));
        const springs = useSpring({
            from: { x: 0 },
            to: isShaking ? [{ x: 4 }, { x: -4 }, { x: 2 }, { x: -2 }, { x: 0 }] : { x: 0 },
            config: { duration: 60 },
            onRest: () => {
                if (isShaking)
                    setIsShaking(false);
            },
        });
        return (_jsx(animated.div, { style: { transform: springs.x.to((x) => `translateX(${x}px)`) }, className: className, children: children }));
    }
    return { default: MotionShakeImpl };
});
/**
 * Shake animation component with Suspense built-in.
 * Applies a damped horizontal oscillation when `shake()` is called via the ref.
 * Lazy loads react-spring only when used.
 */
export function MotionShake(props) {
    return (_jsx(Suspense, { fallback: props.children, children: _jsx(MotionShakeImpl, { ...props }) }));
}
//# sourceMappingURL=MotionShake.js.map